import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Toast, Card, FormLayout, Select, Button, ExceptionList } from '@shopify/polaris';

import TagsInput from 'react-tagsinput';
import DispatchControlOrders from '@presentational/dispatch_control/DispatchControlOrders';

const propTypes = {
  queryOrders: PropTypes.func.isRequired,
  courierOptions: PropTypes.array.isRequired,
  handleOrderIDChange: PropTypes.func.isRequired,
  handleCourierChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,

  orderIds: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  // courierId: PropTypes.string,
};

const defaultProps = {

}


const DispatchControlForm = (props) => (
  <div>
    <Card>
      <Card.Section title={ I18n.t("form.placeholder.dispatch_control.order_ids") }>
        <FormLayout>
          <FormLayout.Group>
            <div>
              <TagsInput
                value={ props.orderIds }
                onlyUnique
                addKeys={[188, 9, 13]}
                inputProps={{
                  placeholder: I18n.t("form.placeholder.dispatch_control.order_ids")
                }}
                addOnPaste
                pasteSplit={
                  (data) => {
                    console.log("pasteSplit",data);
                    return data.split(',').map(d => d.trim())
                }}
                onChange={ props.handleOrderIDChange } />
            </div>
          </FormLayout.Group>
          <FormLayout.Group>
            <Button
              loading={ props.loading }
              onClick={ props.queryOrders }
              primary>
              { I18n.t("actions.generate") }
            </Button>
          </FormLayout.Group>
        </FormLayout>
      </Card.Section>
    </Card>

    {props.orders.length > 0 ? (
      <div className="mt15">
        <FormLayout>
          <FormLayout.Group>
            <Select
              id="courier"
              name="courier"
              label={ I18n.t("activerecord.models.courier.one") }
              options={ props.courierOptions }
              value={ props.courierId }
              onChange={ props.handleCourierChange }
              error={props.errors.courier}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <DispatchControlOrders orders={props.orders} />
          </FormLayout.Group>
          <FormLayout.Group>
            <Button
              loading={ props.loading }
              onClick={ props.handleSubmit }
              primary>
              { I18n.t("actions.create") }
            </Button>
          </FormLayout.Group>
        </FormLayout>
      </div>
    ) : (
      <p></p>
    )
    }
  </div>
);

DispatchControlForm.propTypes = propTypes;
DispatchControlForm.defaultProps = defaultProps;

export default DispatchControlForm;
